<div class="my-5">
    <sm-page-header [breadcrumb]="breadcrumb" title="clarification.reports.create_title"></sm-page-header>
    <div class="content">
        <sm-form-builder *ngIf="formObject" [formObject]="formObject" class="w-full px-4"
            (blur)="onFieldBlur()"></sm-form-builder>

        <div class="flex justify-end gap-2">
            <p-button [label]="'common.save' | translate" severity="success" (click)="save()"
                [disabled]="(isFormValid$ | async) === false"></p-button>
            <p-button [label]="'common.cancel' | translate" severity="secondary" (click)="cancel()"></p-button>
        </div>
    </div>
</div>